import React, { useContext, useEffect, useState } from 'react'
import ProductSlider from './ProductSlider';
import { Link } from 'react-router-dom';
import { ProductContext } from '../contexts/ProductContext';

function AccessoriesFilter() {
    const { products } = useContext(ProductContext);

    const [filterProduct, setfilterProduct] = useState([])
      const [category, setCategory] = useState("Perfume"); // State to track the active tab
      
  
      useEffect(() => {
        
        // const filteredProducts = products.filter(product => product.category.toLocaleLowerCase() === category.toLocaleLowerCase());
        // const newArrivalsFilter = products.filter(product => product.tags.includes("newArrival"));
        // const filteredProducts = products.filter(product => product.title.toLowerCase().includes(category.toLowerCase()));
        if(category){
          const lowerCaseQuery = category?.toLowerCase().trim();
          const filteredProducts = products.filter((product) =>
            // JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)
            JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)
            
          );
          setfilterProduct(filteredProducts)
        }
      }, [category,products])
      
      const handleTabClick = (tabName) => {
        setCategory(tabName);
      };
  
  
  
    return (
      <section id="filter-products" className="mt-4 md:mt-8">
      <div className="flex flex-wrap justify-center items-center gap-2 capitalize tabs-container">
        <button
         className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
          category === "Perfume"
            ? "shadow-lg border-black"
            : ""
        }`}
          onClick={() => handleTabClick("Perfume")}
        >
          Perfumes
        </button>
        <button
          className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
            category === "Shoes"
              ? "shadow-lg border-black"
              : ""
          }`}
          onClick={() => handleTabClick("Shoes")}
        >
         Shoes
        </button>
        <button
          className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
            category === "Sunglasses"
              ? "shadow-lg border-black"
              : ""
          }`}
          onClick={() => handleTabClick("Sunglasses")}
        >
         Sunglasses
        </button>
        <button
          className={`filter-btn  px-4 p-1 border font-secondaryFont text-md text-primary font-semibold tracking-[1px] transition-border duration-500  ${
            category === "Accessories"
              ? "shadow-lg border-black"
              : ""
          }`}
          onClick={() => handleTabClick("Accessories")}
        >
         Accessories
        </button>
      </div>
      <div className="container products-container">
        {category === "Perfume" ? (
          <ProductSlider products={filterProduct}  howManyProductShowCss="w-1/3 lg:w-1/4" />
          // <NewDrops />
        ) : category === "Shoes" ? (
          <ProductSlider products={filterProduct} howManyProductShowCss="w-1/3 lg:w-1/4"/>
          // <Trending />
        ) :category === "Sunglasses" ? (
          <ProductSlider products={filterProduct} howManyProductShowCss="w-1/3 lg:w-1/4"/>
          // <NewDrops />
        ) : category === "Accessories" ? (
          <ProductSlider products={filterProduct} howManyProductShowCss="w-1/3 lg:w-1/4"/>
          // <Trending />
        ) : null}
      </div>
      <div className="p-2 view-all-btn w-full text-center">
      <Link to={`/products`}><button className="hover:shadow-lg px-4 p-1 border hover:border-black font-secondaryFont text-md text-primary tracking-[2px] transition-border duration-300">View All</button></Link>
      </div>
    </section>
    )
  }

export default AccessoriesFilter